<template>
<Row>
	<Cascader
		style="width:100%"
		filterable
		transfer
		:data="areaList" 
		@on-change="change" 
        :placeholder="placeholder"
		:value="handleCode(value)">
	</Cascader>
	<input type="text" :value="value" v-show="false">
</Row>
</template>
<script>
export default {
	data () {
		return {
			areaList:[],
		}
	},
	props:['value','areaCode','changeOnSelect','placeholder','productCode'],
	created () {
		this.queryAreaTreeList()
	},
	methods:{
		 //获取省市区三级联动数据
		async queryAreaTreeList() {
			this.$axios.post('/broker/dict/items/tree.json', {
				bizId:'INDUSTRY_ENTERPRISE',
				companyId:this.getCompanyId(this.$route.query.productCode || this.productCode),
				productCode: this.$route.query.productCode || this.productCode,
				dictCode: 'area_code'
			}).then((res) => {
				this.areaList = JSON.parse(JSON.stringify(res).replace(/value/g,"label").replace(/key/g,"value"))
			})
        },
		handleCode (code){
			if(code){
				let codeArray = []
				if(code.substr(2,4)=='0000'){
					codeArray.push(code)
				}else if(code.substr(4,2)=='00'){
					codeArray.push(code.substr(0,2)+'0000')
					codeArray.push(code.substr(0,4)+'00')
				}else{
					codeArray.push(code.substr(0,2)+'0000')
					codeArray.push(code.substr(0,4)+'00')
					codeArray.push(code)
				}
				return codeArray
			}
		},
		change (code, val) {
			code = code[code.length-1];
			this.$emit('input',code||'');
			this.$emit('get-city-str',val);
		}
	},
	watch:{

	}
}
</script>
<style>
.p2{
	padding: 0 2px;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/Area.vue